import * as types from './types';

const initialState = {
  propertyTypes: null,
  propertySubTypes: null,
  propertyTypesLoading: false,
  propertySubTypesLoading: false,
  propertyTypesError: false,
  propertySubTypesError: false,
  formValues: '',
  originalValues: '',
  hasValues: false,
  disabledBranch: false,
  postingStatuses: [],
  redirectFromAppraisal: false
};

function step1Module1Reducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_REDIRECT_FROM_APPRAISAL:
      return {
        ...state,
        redirectFromAppraisal: true
      };
    case types.GET_PROPERTY_TYPES:
      return {
        ...state,
        propertyTypesLoading: true,
        propertyTypesError: false
      };

    case types.GET_PROPERTY_TYPES_COMPLETED:
      return {
        ...state,
        propertyTypes: [...action.payload],
        propertyTypesLoading: false,
        propertyTypesError: false
      };

    case types.GET_PROPERTY_TYPES_FAILED:
      return {
        ...state,
        propertyTypesLoading: false,
        propertyTypesError: true,
        disabledBranch: action.payload && action.payload.status === 403
      };

    case types.GET_PROPERTY_SUBTYPES:
      return {
        ...state,
        propertySubTypesLoading: true,
        propertySubTypesError: false
      };

    case types.GET_PROPERTY_SUBTYPES_COMPLETED:
      return {
        ...state,
        propertySubTypes: [...action.payload],
        propertySubTypesLoading: false,
        propertySubTypesError: false
      };

    case types.GET_PROPERTY_SUBTYPES_FAILED:
      return {
        ...state,
        propertySubTypesLoading: false,
        propertySubTypesError: true
      };

    case types.SET_PROPERTY_TYPE:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          selectedPropertySubTypeId: '',
          selectedPropertyTypeId: action.payload
        }
      };

    case types.SET_PROPERTY_SUBTYPE:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          selectedPropertySubTypeId: action.payload
        }
      };

    case types.SET_OPERATION_TYPE:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          selectedOperationTypeId: action.payload
        }
      };
    case types.GET_FORM_VALUES:
      return {
        ...state,
        isCompleted: false
      };
    case types.GET_FORM_VALUES_COMPLETED:
      return {
        ...state,
        isCompleted: true,
        formValues: {
          selectedOperationTypeId: action.payload.price_operation_type[0].operation_type,
          selectedPropertyTypeId: action.payload.real_estate_type_id,
          selectedPropertySubTypeId:
            action.payload.real_estate_sub_type_id !== null ? action.payload.real_estate_sub_type_id : ''
        },
        originalValues: {
          operationType: action.payload.price_operation_type[0].operation_type,
          propertyType: action.payload.real_estate_type_id,
          propertySubType: action.payload.real_estate_sub_type_id !== null ? action.payload.real_estate_sub_type_id : ''
        },
        postingStatuses: action.payload.posting_statuses ? action.payload.posting_statuses : []
      };
    case types.SET_EDIT_VALUES:
      return {
        ...state,
        hasValues: true
      };
    case types.SET_DISABLED_BRANCH:
      return {
        ...state,
        disabledBranch: action.payload
      };
    case types.CLEAN_VALUES:
      return initialState;
    default:
      return state;
  }
}

export { step1Module1Reducer };
